'use client';

import { useEffect } from 'react';
import { cookieManager } from '../lib/cookieManager';

/**
 * Cookie Initializer Component
 * This component initializes tracking based on stored cookie preferences
 * It should be included in the root layout to run on every page load
 */
export function CookieInitializer() {
  useEffect(() => {
    // Initialize tracking based on stored preferences
    cookieManager.initializeTracking();
  }, []);

  // This component renders nothing - it only runs initialization logic
  return null;
}